import { useEffect, useState } from "react"
import { Community, Event, User } from "../../types"
import { searchCommunities, searchEvents, searchUsers, searchBadges, getGames } from "../../actions"
import { Badge, Game } from "@smerf-gaming/types"

type returnType = [User[] | Community[] | Event[] | Badge[] | Game[], (query: string) => void, boolean]

export const useUsers = (): returnType => {
  const [users, setUsers] = useState<User[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const search = async (query: string) => {
    setLoading(true)
    setUsers(await searchUsers(query))
    setLoading(false)
  }

  return [users, search, isLoading]
}

export const useCommunities = (): returnType => {
  const [communities, setCommunities] = useState<Community[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const search = async (query: string) => {
    setLoading(true)
    // TODO : use search pagination
    const communityData = await searchCommunities(query)
    setCommunities(communityData.content)
    setLoading(false)
  }

  return [communities, search, isLoading]
}

export const useEvents = (): returnType => {
  const [events, setEvents] = useState<Event[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const search = async (query: string) => {
    setLoading(true)
    // TODO : use search pagination
    const eventData = await searchEvents(query)
    setEvents(eventData.content)
    setLoading(false)
  }

  return [events, search, isLoading]
}

export const useBadges = (): returnType => {
  const [badges, setBadges] = useState<Badge[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const search = async (query: string) => {
    setLoading(true)
    setBadges(await searchBadges(query))
    setLoading(false)
  }

  return [badges, search, isLoading]
}

export const useGames = (): returnType => {
  const [games, setGames] = useState<Game[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const search = async (query: string) => {
    setLoading(true)
    const allGames = await getGames()
    const filteredGames = allGames?.filter(g => g.name.includes(query))
    setGames(filteredGames ?? [])
    setLoading(false)
  }

  useEffect(() => {
    search("")
  }, [])

  return [games, search, isLoading]
}
